import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {ProductStockUnitModel} from "../../../api/entity/productStockUnit.model";
import {ProductStockUnitConverter} from "../../../api/entity/converter/productStockUnit.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";


@Injectable({
    providedIn: 'root'
})
export class ProductStockUnitDataService extends AbstractDataServiceV2<ProductStockUnitModel, ProductStockUnitConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: ProductStockUnitConverter) {
        super('ProductStockUnit', http, httpUrlGenerator, logger, config, converter);
    }
}
